export default __webpack_public_path__ + "static/media/lungs_img_0006_Free_Health_Information.f104c9d6.png";